import classNames from "classnames";
import "./AppToggle.css";

export default function AppToggle({
  checked = false,
  disabled,
  text,
  onChange,
}: {
  checked?: boolean;
  disabled?: boolean;
  text: string;
  onChange: (checked: boolean) => void;
}) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(event.target.checked);
    }
  };

  return (
    <div className="app-toggle">
      <div className="app-toggle-left">{text}</div>
      <label className="switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span
          className={classNames("slider round", {
            "slider--disabled": disabled,
          })}
        ></span>
      </label>
    </div>
  );
}
